<template>
    <div class="services">
        <div v-if="currentImmobile.Adsl" class="services__item">
            Adsl
        </div>
        <div v-if="currentImmobile.AnimaliConsentiti" class="services__item">
            Animali Consentiti
        </div>
        <div v-if="currentImmobile.AntennaSat" class="services__item">
            Antenna Sat
        </div>
        <div v-if="currentImmobile.AntennaTV" class="services__item">
            Antenna TV
        </div>
        <div v-if="currentImmobile.Caminetto" class="services__item">
            Caminetto
        </div>
        <div v-if="currentImmobile.CampoDaTennis" class="services__item">
            Campo Da Tennis
        </div>
        <div v-if="currentImmobile.Cantina" class="services__item">
            Cantina
        </div>
        <div v-if="currentImmobile.Citofono" class="services__item">
            Citofono
        </div>
        <div v-if="currentImmobile.Domotica" class="services__item">
            Domotica
        </div>
        <div v-if="currentImmobile.FibraOttica" class="services__item">
            FibraOttica
        </div>
        <div v-if="currentImmobile.Geotermico" class="services__item">
            Geotermico
        </div>
        <div v-if="currentImmobile.IngressoPrivato" class="services__item">
            Ingresso Privato
        </div>
        <div v-if="currentImmobile.Lavanderia" class="services__item">
            Lavanderia
        </div>
        <div v-if="currentImmobile.Mansarda" class="services__item">
            Mansarda
        </div>
        <div v-if="currentImmobile.PannelliFotovoltaici" class="services__item">
            Pannelli Fotovoltaici
        </div>
        <div v-if="currentImmobile.PannelliSolariTermici" class="services__item">
            Pannelli Solari Termici
        </div>
        <div v-if="currentImmobile.Piscina" class="services__item">
            Piscina
        </div>
        <div v-if="currentImmobile.PostoBarca" class="services__item">
            Posto Barca
        </div>
        <div v-if="currentImmobile.Ripostiglio" class="services__item">
            Ripostiglio
        </div>
        <div v-if="currentImmobile.SalaDaPranzo" class="services__item">
            Sala da pranzo
        </div>
        <div v-if="currentImmobile.Soffitta" class="services__item">
            Soffitta
        </div>
        <div v-if="currentImmobile.Soggiorno" class="services__item">
            Soggiorno
        </div>
        <div v-if="currentImmobile.Soppalco" class="services__item">
            Soppalco
        </div>
        <div v-if="currentImmobile.Spiaggia" class="services__item">
            Spiaggia
        </div>
        <div v-if="currentImmobile.Studio" class="services__item">
            Studio
        </div>
        <div v-if="currentImmobile.Taverna" class="services__item">
            Taverna
        </div>
        <div v-if="currentImmobile.TerrazzoAbitabile" class="services__item">
            Terrazzo Abitabile
        </div>
        <div v-if="currentImmobile.Veranda" class="services__item">
            Veranda
        </div>
        <div v-if="currentImmobile.VideoCitofono" class="services__item">
            Video Citofono
        </div>

    </div>
</template>
<script>
    export default {
        name: 'services',
        props: {
            currentImmobile: {}
        }
    }
</script>
<style lang="scss">
    .services {
        @apply flex flex-wrap -mx-4;
        &__item {
            @apply w-1/2 px-4;
            &:before {
                content: '•';
                @apply mr-2;
            }
            @screen md {
                @apply w-1/3
            }
        }
    }
</style>
